import React from 'react';

const MapStatsPanel = ({
  filteredMapResults,
  totalResults,
  mapResults,
  categories,
  selectedDocTypes,
  documentTypes,
  refreshMapDots,
  refreshingDots,
  refreshProgress,
  cleanMapDots,
  cleaningDots,
  clearAllDots,
  clearingDots,
  cleanProgress,
  dataSource,
  lastUpdate
}) => {
  return (
    <div style={{
      flex: 1,
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(253, 251, 247, 0.9))',
      borderRadius: 12,
      border: '1px solid rgba(252, 211, 77, 0.3)',
      padding: 20,
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
      maxHeight: 550,
      overflowY: 'auto'
    }}>
      <h4 style={{ color: '#047857', margin: 0, fontSize: '1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
        <i className="fas fa-chart-bar" /> Map Statistics
      </h4>

      {/* Quick Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <div style={{ background: 'rgba(16, 185, 129, 0.15)', borderRadius: 8, padding: 12, border: '1px solid rgba(16, 185, 129, 0.3)' }}>
          <div style={{ color: '#10b981', fontSize: '1.5rem', fontWeight: 700 }}>{filteredMapResults.length}</div>
          <div style={{ color: '#71717a', fontSize: '0.75rem' }}>Dots on Map</div>
        </div>
        <div style={{ background: 'rgba(245, 158, 11, 0.15)', borderRadius: 8, padding: 12, border: '1px solid rgba(245, 158, 11, 0.3)' }}>
          <div style={{ color: '#3b82f6', fontSize: '1.5rem', fontWeight: 700 }}>{totalResults || mapResults.length}</div>
          <div style={{ color: '#71717a', fontSize: '0.75rem' }}>Total URLs in DB</div>
        </div>
        <div style={{ background: 'rgba(253, 230, 138, 0.15)', borderRadius: 8, padding: 12, border: '1px solid rgba(253, 230, 138, 0.3)' }}>
          <div style={{ color: '#047857', fontSize: '1.5rem', fontWeight: 700 }}>{categories.length}</div>
          <div style={{ color: '#71717a', fontSize: '0.75rem' }}>Categories</div>
        </div>
        <div style={{ background: 'rgba(245, 158, 11, 0.15)', borderRadius: 8, padding: 12, border: '1px solid rgba(245, 158, 11, 0.3)' }}>
          <div style={{ color: '#f59e0b', fontSize: '1.5rem', fontWeight: 700 }}>
            {selectedDocTypes.length}/{documentTypes.length}
          </div>
          <div style={{ color: '#71717a', fontSize: '0.75rem' }}>Doc Types</div>
        </div>
      </div>

      {/* Map Actions */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {/* Refresh Map Dots Button */}
        <button
          onClick={refreshMapDots}
          disabled={refreshingDots}
          data-testid="map-page-refresh-dots-btn"
          style={{
            width: '100%', padding: '10px 14px', fontSize: '0.85rem',
            background: refreshingDots ? 'rgba(245, 158, 11, 0.2)' : 'linear-gradient(135deg, rgba(16,185,129,0.2), rgba(245, 158, 11,0.2))',
            border: `1px solid ${refreshingDots ? 'rgba(245,158,11,0.4)' : 'rgba(16,185,129,0.4)'}`,
            borderRadius: 8, color: refreshingDots ? '#f59e0b' : '#10b981',
            cursor: refreshingDots ? 'wait' : 'pointer', fontWeight: 700
          }}
        >
          {refreshingDots ? (
            <><i className="fas fa-sync-alt fa-spin" style={{ marginRight: 6 }} /> Refreshing Dots...</>
          ) : (
            <><i className="fas fa-map-pin" style={{ marginRight: 6 }} /> Refresh Map Dots</>
          )}
        </button>

        {/* Clean Map Dots Button */}
        {cleanMapDots && (
          <button
            onClick={cleanMapDots}
            disabled={cleaningDots || clearingDots}
            data-testid="map-page-clean-dots-btn"
            style={{
              width: '100%', padding: '10px 14px', fontSize: '0.85rem',
              background: cleaningDots ? 'rgba(245, 158, 11, 0.2)' : 'rgba(245, 158, 11, 0.15)',
              border: `1px solid ${cleaningDots ? 'rgba(245,158,11,0.4)' : 'rgba(245, 158, 11, 0.4)'}`,
              borderRadius: 8, color: cleaningDots ? '#f59e0b' : '#3b82f6',
              cursor: cleaningDots ? 'wait' : 'pointer', fontWeight: 700
            }}
          >
            {cleaningDots ? (
              <><i className="fas fa-sync-alt fa-spin" style={{ marginRight: 6 }} /> Cleaning Dots...</>
            ) : (
              <><i className="fas fa-broom" style={{ marginRight: 6 }} /> Clean Map Dots</>
            )}
          </button>
        )}

        {/* Clear All Dots Button */}
        {clearAllDots && (
          <button
            onClick={clearAllDots}
            disabled={cleaningDots || clearingDots}
            data-testid="map-page-clear-all-dots-btn"
            style={{
              width: '100%', padding: '10px 14px', fontSize: '0.85rem',
              background: clearingDots ? 'rgba(245, 158, 11, 0.2)' : 'rgba(239, 68, 68, 0.12)',
              border: `1px solid ${clearingDots ? 'rgba(245,158,11,0.4)' : 'rgba(239, 68, 68, 0.4)'}`,
              borderRadius: 8, color: clearingDots ? '#f59e0b' : '#ef4444',
              cursor: clearingDots ? 'wait' : 'pointer', fontWeight: 700
            }}
          >
            {clearingDots ? (
              <><i className="fas fa-sync-alt fa-spin" style={{ marginRight: 6 }} /> Clearing...</>
            ) : (
              <><i className="fas fa-trash-alt" style={{ marginRight: 6 }} /> Clear All Dots (Fresh Start)</>
            )}
          </button>
        )}
      </div>

      {/* Progress Messages */}
      {(refreshProgress || cleanProgress) && (
        <div style={{ color: '#a1a1aa', fontSize: '0.7rem', textAlign: 'center' }}>{cleanProgress || refreshProgress}</div>
      )}

      {/* Data Source Info */}
      <div style={{
        background: 'rgba(252, 211, 77, 0.1)',
        borderRadius: 8,
        padding: 12,
        border: '1px solid rgba(252, 211, 77, 0.2)'
      }}>
        <div style={{ color: '#047857', fontSize: '0.85rem', fontWeight: 600, marginBottom: 5 }}>
          {dataSource === 'worldwide' ? <><i className="fas fa-globe" /> Worldwide Data</> : <><i className="fas fa-user" /> Personal Data</>}
        </div>
        <div style={{ color: '#71717a', fontSize: '0.75rem' }}>
          {dataSource === 'worldwide'
            ? 'Showing results from all public sources'
            : 'Showing only your categorized results'}
        </div>
      </div>

      {/* Last Update */}
      {lastUpdate && (
        <div style={{
          color: '#71717a',
          fontSize: '0.7rem',
          textAlign: 'center',
          marginTop: 'auto',
          paddingTop: 10,
          borderTop: '1px solid rgba(255,255,255,0.1)'
        }}>
          Last updated: {lastUpdate.toLocaleTimeString()}
        </div>
      )}
    </div>
  );
};

export default MapStatsPanel;
